module.exports = __webpack_public_path__ + "img/home_icon1@2x.fdc87bba.png";